// extracted by mini-css-extract-plugin
export default {"upload":"SignUp_upload__rUQmS","checkbox":"SignUp_checkbox__3F-Qg","link":"SignUp_link__W4inB"};